import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const ChannelPushIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <Path
            fillRule='nonzero'
            d='M11.376 5.497H4.67c-.261 0-.473.245-.473.546V18.09c0 .3.212.545.473.545h6.707c.262 0 .474-.244.474-.545V6.043c0-.301-.212-.546-.474-.546zm-.65 11.15H5.32V6.716h5.406v9.93zM16.588 7.05l1.009-1.124c1.813 1.625 2.745 3.455 2.745 5.46 0 1.96-.812 3.97-2.406 6.026l-1.195-.926c1.403-1.81 2.09-3.509 2.09-5.1 0-1.544-.731-2.98-2.243-4.335zm-2.216 2.317l.995-1.138c1.106.968 1.682 2.113 1.682 3.397 0 1.269-.602 2.525-1.76 3.766l-1.105-1.03c.918-.984 1.354-1.895 1.354-2.736 0-.824-.373-1.565-1.166-2.26z'
            fill='currentColor'
        />
    ),
})

ChannelPushIcon.displayName = 'ChannelPushIcon'
